"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _GameCard = _interopRequireDefault(require("./GameCard"));

var _constants = require("./constants");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var GameDeck = /*#__PURE__*/function () {
  function GameDeck() {
    _classCallCheck(this, GameDeck);

    _defineProperty(this, "cards", []);

    _defineProperty(this, "trump", null);

    this.initCards();
    this.shuffle();
    this.setTrump();
  }

  _createClass(GameDeck, [{
    key: "initCards",
    value: function initCards() {
      this.cards = [];

      for (var _i = 0, _Object$values = Object.values(_constants.SUITS); _i < _Object$values.length; _i++) {
        var suit = _Object$values[_i];

        for (var _i2 = 0, _Object$values2 = Object.values(_constants.RANKS); _i2 < _Object$values2.length; _i2++) {
          var rank = _Object$values2[_i2];
          this.cards.push(new _GameCard["default"]({
            suit: suit,
            rank: rank
          }));
        }
      }
    }
  }, {
    key: "shuffle",
    value: function shuffle() {
      var cards = this.cards;

      for (var i = cards.length - 1; i > 0; i--) {
        var j = Math.floor(Math.random() * (i + 1));
        var _ref = [cards[j], cards[i]];
        cards[i] = _ref[0];
        cards[j] = _ref[1];
      }
    }
  }, {
    key: "setTrump",
    value: function setTrump() {
      var _this = this;

      this.trump = this.cards[0];
      this.cards.filter(function (card) {
        return card.suit === _this.trump.suit;
      }).forEach(function (card) {
        return card.setTrump(true);
      });
    }
  }, {
    key: "pop",
    value: function pop() {
      return this.cards.pop();
    }
  }, {
    key: "isEmpty",
    get: function get() {
      return this.cards.length === 0;
    }
  }, {
    key: "length",
    get: function get() {
      return this.cards.length;
    }
  }]);

  return GameDeck;
}();

exports["default"] = GameDeck;